var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"bounce"}},[(_vm.open)?_c('div',{staticClass:"alert-container"},[_c('v-alert',{attrs:{"type":_vm.alert.type}},[_vm._v(_vm._s(_vm.alert.message))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }